import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";

export interface ITrackAmplitudeListingFiltersAdditionalParams {
    filter_name: "rooms" | "price";
    filter_value: string | undefined;
    latestQuery: IOfferListLatestQuery;
}

export const trackAmplitudeListingFiltersAdditional = ({filter_name, filter_value, latestQuery}: ITrackAmplitudeListingFiltersAdditionalParams) => {
    if (!filter_value) {
        return;
    }

    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery);

    trackAmplitudeEvent("listing_filters_additional", {
        filter_name,
        filter_value,
        ...(item_list_id ? {item_list_id} : {})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";

export interface ITrackAmplitudeListingFiltersAdditionalParams {
    filter_name: "rooms" | "price";
    filter_value: string | undefined;
    latestQuery: IOfferListLatestQuery;
}

export const trackAmplitudeListingFiltersAdditional = ({filter_name, filter_value, latestQuery}: ITrackAmplitudeListingFiltersAdditionalParams) => {
    if (!filter_value) {
        return;
    }

    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery);

    trackAmplitudeEvent("listing_filters_additional", {
        filter_name,
        filter_value,
        ...(item_list_id ? {item_list_id} : {})
    });
};
